<template>
  <transition name="bg-game-preview">
    <div
      v-if="visible && game"
      class="bg-game-preview-overlay"
      role="presentation"
      @click.self="close"
    >
      <div
        class="bg-game-preview"
        role="dialog"
        aria-modal="true"
        :aria-label="game.name"
        @keydown.esc.prevent="close"
      >
        <header class="bg-game-preview__top">
          <div class="bg-game-preview__badges">
            <span
              v-if="statusBadge"
              class="bg-game-preview__pill"
              :class="statusBadge === 'NEW' ? 'bg-game-preview__pill--new' : 'bg-game-preview__pill--hot'"
            >{{ statusBadge }}</span>
            <span class="bg-game-preview__pill bg-game-preview__pill--slot">{{ categoryLabel }}</span>
          </div>
          <button type="button" class="bg-game-preview__close" :aria-label="$t('common.close')" @click="close">
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
              <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
        </header>

        <div class="bg-game-preview__hero">
          <img
            class="bg-game-preview__img"
            :src="game.image || fallbackImg"
            :alt="game.name"
            @error="onImgError"
          >
        </div>

        <footer class="bg-game-preview__footer">
          <div class="bg-game-preview__info">
            <h2 class="bg-game-preview__title">{{ game.name }}</h2>
            <p v-if="game.provider_name" class="bg-game-preview__provider">{{ game.provider_name }}</p>
            <p class="bg-game-preview__tagline">{{ $t('games.previewTagline') }}</p>
          </div>
          <div class="bg-game-preview__actions">
            <button
              type="button"
              class="bg-game-preview__btn bg-game-preview__btn--play"
              @click="$emit('play-real')"
            >
              <i class="fas fa-circle-play" aria-hidden="true" />
              {{ $t('games.play') }}
            </button>
            <button
              v-if="showDemo"
              type="button"
              class="bg-game-preview__btn bg-game-preview__btn--demo"
              @click="$emit('play-demo')"
            >
              <i class="fas fa-gift" aria-hidden="true" />
              {{ $t('games.demo') }}
            </button>
          </div>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import { getHotGameBadge } from '@/utils/game'

const FALLBACK_IMG = 'data:image/svg+xml,' + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="440" height="300" viewBox="0 0 440 300">' +
  '<rect width="440" height="300" fill="#151515"/>' +
  '</svg>'
)

export default {
  name: 'BlackGoldGamePreviewModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    game: {
      type: Object,
      default: null
    },
    categoryLabel: {
      type: String,
      default: 'SLOT'
    },
    showDemo: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      fallbackImg: FALLBACK_IMG
    }
  },
  computed: {
    statusBadge () {
      if (!this.game) return ''
      const badge = getHotGameBadge(this.game)
      if (badge === 'NEW') return 'NEW'
      if (this.game.is_hot || badge === 'HOT') return 'HOT'
      return ''
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    onImgError (event) {
      if (event && event.target) {
        event.target.src = this.fallbackImg
      }
    }
  }
}
</script>
